import { Injectable, inject } from '@angular/core';
import { ICategoryDataV3 } from '@df/catalog/category/category';
import { CategoryResource } from '@df/catalog/category/category.resource';
import { MetaState } from '@df/core/meta/meta';
import { NFacetUrl } from '@df/module-facet-url/core/facet.interfaces';
import { FacetUrlMetaPluginService } from '@df/module-facet-url/plugin/meta.plugin.service';
import { Subscription } from 'rxjs';
import { Category } from '../../catalog/category/category.decorator';

declare module '@df/module-facet-url/core/facet.interfaces' {
    namespace NFacetUrl {
        interface IFacetData {
            h1: string;
            faq_title?: string;
            custom_schema?: string;
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocalFacetUrlMetaPluginService extends FacetUrlMetaPluginService {
    private categoryResource = inject(CategoryResource);

    private subscription?: Subscription;

    protected override onMetaStateChange(state: MetaState, facetData: NFacetUrl.IFacetData) {
        super.onMetaStateChange(state, facetData);
        const category = this.categoryResource.getExisting(facetData.category) as Category<ICategoryDataV3>;
        this.subscription?.unsubscribe();
        if (category && facetData.h1) {
            const crumb = {
                url: facetData.id,
                label: facetData.h1
            };
            this.subscription = state.breadcrumbs$.subscribe(breadcrumbs => {
                if (!breadcrumbs?.includes(crumb)) {
                    breadcrumbs?.push(crumb);
                }
            });
            category.data?.breadcrumbs && state.breadcrumbs$.next([...category.data.breadcrumbs]);
        }
    }
}
